import { currentPage } from '../common/layout';
import { getNewsletterWidget } from '../common/widgets/widget-newsletter-loader';
// import '../common/jquery.sticky';

currentPage.pageInit = ($page, pageData, pageId) => {
  let newsLetterWidget = document.querySelector('.widget-newsletter');
  if (newsLetterWidget) {
    getNewsletterWidget().then((api) => {
      api.newsletter();
    });
  }
  // $('.sidebar').stickySidebar({ containerSelector: '.content-area' });
};
